export function setData ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    commit('setData', payload)
    resolve({ status: true })
  })
}
